<template>
  <router-view />
</template>

<script>
export default {
  name: "app-courseCategory"
};
</script>

<style lang="scss" scoped></style>
